import { type TeamData, isSunrun, type CompanyId } from '@terros/common'

export const useCanUpdateSunrunTeam = (companyId?: CompanyId, team?: TeamData): boolean => {
  const sunrun = isSunrun(companyId)
  if (sunrun && team?.level === 2) return false
  return true
}
